<template>
    <div :class="className" style="position: relative; margin-right: 10px;line-height: 32px;display: flex;align-items: center;" >
        <div v-if="showFlag" class="flag-cover" :style="{ 'background-image': `url(${countryInfo.img})` }"></div>
        <div class="theme-menu-item select-language " @click="clickLanguage">
            <span>{{ country }}</span>
            <span class="theme-menu-line"></span>
            <span>{{ language }}</span>
            <span class="arrow-icon" :class="{ 'icon-active': dropActive }">   
                <cy-icon type="arrow" ></cy-icon>
            </span>
        </div>
        <div class="header-select-country-language-content" :class="{ 'active': dropActive }">
            <div class="content-item" v-for="item in popInfo" :key="item.settings.iso_code + '-' + item.settings.language"
                @click="() => selectLanguage(item)">
                <div class="text">
                    <span class="checkPart"
                        :class="{ 'checked': activeInfo.country === item.settings.iso_code && activeInfo.language === item.settings.language_iso_code }"></span>
                    <span>{{ item.settings.language }} </span>
                </div>
            </div>
            <div class="content-item">
                <div class="text" style="align-items: flex-start;" @click="switchToSelect">
                    <div class="content-item-icon" :style="{ 'background-image': `url(${countryInfo.img})` }">
                    </div>
                    <div class="flex" style="flex-direction: column; margin-left: 10px;">
                        <div style="line-height: 18px;">{{ countryInfo.name }}</div>
                        <span class="switch">Switch region</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="fixed-country-select" v-show="selectActive">
            hahahah
        </div> -->
    </div>
</template>

<script>
export default {
    name: 'cyLanguage',
    props: {
        className: {
            type: String,
            default: '',
        },
        showFlag: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        const {
            country, // localization.country.iso_code
            language,
            availableLocales,
            countryInfo,
        } = window.globalNavConfig || {};

        const popInfo = availableLocales.filter(item => item.settings.iso_code === country)
        return {
            country,
            language,
            availableLocales,
            countryInfo,
            popInfo,
            status: 'normal', // dropdown 下拉框选择/ popup 全屏选择
            dropActive: false,
            selectActive: false,
            activeInfo: {
                country,
                language: language.toLowerCase(),
            },
        }
    },
    methods: {
        clickLanguage() {
            this.dropActive = !this.dropActive;
        },
        selectLanguage(item) {
            this.dropActive = false;
            console.log('change language...', item)
            this.activeInfo = {
                country: item.settings.iso_code,
                language: item.settings.language_iso_code,
            }
            this.changeLanguage(item.settings.languageValue)
        },
        switchToSelect() {
            this.dropActive = false;
            // this.selectActive = true;
            let selectCountryMask = document.querySelector('.select-countryRegion-content__background')
            let selectCountryContent = document.querySelector('.select-countryRegion-content')
            selectCountryMask.classList.add('select-countryRegion-content__background-show')
            selectCountryContent.classList.add('select-countryRegion-content-show')
        },
        changeLanguage(url) {
            var pathname = window.location.pathname.replace(new RegExp('/de', 'g'), '').replace(new RegExp('/fr', 'g'), '').replace(new RegExp('/nl', 'g'), '')
            var path = (window.location.pathname === '/' ? '' : pathname) + window.location.search
            if (url == '/') {
                window.location.href = (((window.location.pathname === '/de' || window.location.pathname === '/fr' || window.location.pathname === '/nl') ? '/' : path ? '' : '/') + path)
            } else {
                window.location.href = url + path
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.select-language {
    margin-right: 10px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;

    .theme-menu-line {
        display: inline-block;
        width: 1px;
        height: 10px;
        background-color: #282828;
        margin: 0 5px;
    }

    &::v-deep svg {
        margin-left: 2px;
        width: 12px;
        height: 12px;
    }
    .arrow-icon {
        transition: transform .3s cubic-bezier(.4, 0, .2, 1);
        transform: rotate(0deg);

        &.icon-active {
            transform: rotate(-180deg);
        }
    }
   
}

.header-select-country-language-content {
    visibility: hidden;
    position: absolute;
    top: 30px;
    left: -50px;
    width: 190px;
    background: #fff;
    border-radius: 14px;
    transition: all .3s cubic-bezier(.4, 0, .2, 1);
    transform: translateY(-15px);
    min-width: 190px;
    opacity: 0;
    color: red;
    overflow: hidden;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    z-index: 999;

    &.active {
        visibility: visible;
        transform: none;
        background: #FFFFFF;
        opacity: 1;
    }

    .content-item {
        &:hover {
            background-color: #FAFAF6;

            .text {
                .switch {
                    text-decoration: none !important;
                }
            }
        }

        .text {
            display: flex;
            align-items: center;
            padding: 14px 20px;
            cursor: pointer;
            width: 100%;
            font-size: 14px;
            font-weight: 600;
            color: #282828;

            .switch {
                font-size: 14px;
                // font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #7AAC64;
                line-height: 20px;
                text-decoration: underline;
                text-underline-offset: 4px;
            }

            .content-item-icon {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 20px;
                height: 20px;
                border-radius: 10px;
                overflow: hidden;
                // background-image: url(//cdn.shopify.com/static/images/flags/de.svg?crop=center&height=25&width=25);
                background-repeat: no-repeat;
                background-size: cover;
            }

            .checkPart {
                position: relative;
                border-radius: 50%;
                width: 20px;
                height: 20px;
                background: #FAFAF6;
                border: 2px solid #CCCCCC;
                margin-right: 10px;
                appearance: none;

                &.checked {
                    display: inline-block;
                    -webkit-appearance: none;
                    background-color: #FAFAF6;
                    position: relative;
                    border: 2px solid #3B4B31;
                    border-radius: 50%;
                    outline: none;
                    cursor: pointer;

                    &:after {
                        position: absolute;
                        content: '';
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                        width: 16px;
                        height: 16px;
                        border-radius: 50%;
                        background-color: #BDFBA2;
                        font-size: 12px;
                        text-align: center;
                        line-height: 16px;
                        font-weight: 600;
                        background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+6Lev5b6EQDF4PC90aXRsZT4KICAgIDxnIGlkPSJzdGVwMumHjeaehCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IuivreiogOmAieaLqeWFpeWPoyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExMjIuMzM1Nzg1LCAtMTkyLjAwMDAwMCkiIGZpbGw9IiMzQjRCMzEiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxnIGlkPSLnvJbnu4QtNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEyMi4zMzU3ODUsIDE5Mi4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMi42MzIxMjM2LDYuMTkzNzkwNzYgTDcuOTg1Mzk4MzYsMTAuODQwNTE2IEM3Ljc3Mjc1MzA1LDExLjA1MzE2MTMgNy40MjgyNjc2NSwxMS4wNTMxNjEzIDcuMjE1NjIyMzQsMTAuODQwNTE2IEw0LjAzOTU1MjAzLDcuNjY0NDQ1NyBDMy45ODY4MTU5OSw3LjYxMTcwOTY3IDMuOTg2ODE1OTksNy41MjQ5NTAzOCA0LjAzOTU1MjAzLDcuNDcyMjE0MzUgTDUuMDAxNTU5NCw2LjUxMDIwNjk3IEM1LjA1NDI5NTQ0LDYuNDU3NDcwOTQgNS4xNDEwNTQ3Miw2LjQ1NzQ3MDk0IDUuMTkzNzkwNzYsNi41MTAyMDY5NyBMNy41NTE2MDE5Myw4Ljg2ODAxODE1IEM3LjU3Nzk2OTk1LDguODk0Mzg2MTYgNy42MjEzNDk1OSw4Ljg5NDM4NjE2IDcuNjQ3NzE3NjEsOC44NjgwMTgxNSBMMTEuNDc3MDM0Myw1LjAzOTU1MjAzIEMxMS41Mjk3NzAzLDQuOTg2ODE1OTkgMTEuNjE2NTI5Niw0Ljk4NjgxNTk5IDExLjY2OTI2NTcsNS4wMzk1NTIwMyBMMTIuNjMxMjczLDYuMDAxNTU5NCBDMTIuNjg0ODU5Nyw2LjA1NDI5NTQ0IDEyLjY4NDg1OTcsNi4xNDEwNTQ3MiAxMi42MzIxMjM2LDYuMTkzNzkwNzYgWiIgaWQ9Iui3r+W+hCI+PC9wYXRoPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=);
                    }
                }
            }
        }
    }
}

.flag-cover {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: cover;
    margin-right: 10px;
}

.in-m {
    .header-select-country-language-content {
        left: -10px !important;
    }
}

.language-back {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0,0.5);
}
</style>